<script lang="ts">
    import type {FieldTypeId} from 'src/typings';
    import type {Row} from '@tanstack/svelte-table';
    import type {HierarchicalRecordRow} from '../../lib/types';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';

    export let row: Row<HierarchicalRecordRow>;
    export let recordLinkFieldTypeId: FieldTypeId | null = null;

    $: currentRecordRow = row.original;

    function getRecordLink(): string {
        const linkField = getFirstFieldByFieldTypeIdRecursive(currentRecordRow, recordLinkFieldTypeId);
        const id = linkField?.originRecordReference?.id ?? linkField?.targetRecordReference?.id ?? currentRecordRow.id;
        return `/#!/records/${id}`;
    }
</script>

<div class="kp-grid-record-link-control-cell">
    <KpButtonStyleAnchor href={getRecordLink()} title="Zobrazit záznam" buttonSize="xs" buttonStyle="link">
        <IconedContent icon="eye"/>
    </KpButtonStyleAnchor>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-grid-record-link-control-cell {
        display: flex;
        overflow: hidden;
        height: 100%;

        :global(.kp-button-style-link) {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: transparent;
            transition: background-color 0.2s ease;
            color: var(--brand-orange);
            border-radius: 0 !important;

            &:hover {
                background-color: @themed-body-bg-orange-highlighted;
                text-decoration: none;
            }
        }
    }

    :global {
        .cell-content:has(.kp-grid-record-link-control-cell) {
            padding: 0 !important;
        }
    }
</style>